/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `0` - Origin
* `1` - Destination
 */
export type LocationEnum = typeof LocationEnum[keyof typeof LocationEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocationEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
